var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapa-container"},[_c('Mapa',{ref:"mapa",attrs:{"showStatesLayers":true,"mapLayersConfigs":_vm.layersMaps,"mapConfig":_vm.mapConfig,"height":"450px","idMapa":"MapaConcentracaoVolumeContratos","atualizarMapa":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }